import _ from 'lodash';
import { Toastify } from '.';

const MESSAGES = {
  invalidEmail: 'Email is invalid.',
  invalidPhone: 'Phone number is invalid.',
  unknown: 'An error has occurred.',
  required: 'Field cannot be blank.',
  accountNotExist: 'Username does not exist.',
  incorrectAccount: 'Incorrect username or password.',
  inValidDailyJobs: 'Please enter all required fields.',
  inValidDailyJobsHour: 'Hours is invalid.',
  tooManyWorkHours: 'Too many work hours. Either adjust the Start Time or Task Hours.',
  textMaxLength: 'Name must be less than 255 characters.',
  textShortMaxLength: 'Name must be less than 150 characters.',
  emailLength: 'Email must be less than 50 characters.',
  commentNotWorked: 'Comments are required if the employee did not work this day.',
  commentSubmittedTimesheet: 'Comments are required when Submitted Timesheet is edited.',
  descriptionMaxLength: 'Description must be less than 255 characters.',
  commentMaxLength: 'Comment must be less than 255 characters.',
  commentOtherRequired: 'Comment are required for Other.',

  invalidJobCode: 'Code must be exactly 4 digits.',
  invalidPhaseCode: 'Code must be exactly 5 digits.',
  invalidEmployeeID: 'Employee ID must be exactly 8 characters.',
};

const handler = (error: AuthError | Error) => {
  console.error(error);
  Toastify.error(error?.message || MESSAGES.unknown);
};

const asyncFailure = (error: { message: any[] | string }) => {
  if (typeof error.message === 'string') {
    const message = error.message;
    Toastify.error(message || MESSAGES.unknown);
    return message;
  }
  const message = error.message?.map(mes => `${mes?.msg} ${_.startCase(mes?.param)}`).join('. ');
  Toastify.error(message || MESSAGES.unknown);
  return message;
};

export default {
  handler,
  asyncFailure,
  MESSAGES,
};
